import type { NavigateFunction } from 'react-router-dom';
import { useUIStore } from '@/src/store/useUIStore';
import { containerPathToWebRoute } from './containerPaths';

export function createWebNavigateHandler(navigate: NavigateFunction) {
  return (path: string) => {
    navigate(containerPathToWebRoute(path));
  };
}

export function createWebConfirmHandler() {
  return (title: string, message: string, onConfirm: () => void) => {
    useUIStore.getState().setConfirmDialog({
      isOpen: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        useUIStore.getState().setConfirmDialog({
          isOpen: false,
          title: '',
          message: '',
          onConfirm: () => {},
        });
      },
    });
  };
}
